<template>
  <div :class="['content-background', overlayComp]">
    <picture>
      <source media="(max-width: 480px)" :srcset="imageMobile">
      <source media="(min-width: 481px) and (max-width: 1024px)" :srcset="imageTablet">
      <img :src="imageDesktop" :style="backgroundColor" :alt="alt" class="content-background__image" loading="lazy" />
    </picture>
  </div>
</template>

<script>
export default {
  name: 'content-background',
  props: {
    backgroundColor: {
      type: String,
      default: null
    },
    overlay: {
      type: Number,
      default: null
    },
    alt: {
      type: String,
    },
    imageMobile: {
      type: String,
      default: ''
    },
    imageTablet: {
      type: String,
      default: ''
    },
    imageDesktop: {
      type: String,
      default: null
    }
  },
  computed: {
    overlayComp() {
      return `content-background--overlay-${this.overlay}`
    }
  }
}
</script>

<style lang="scss" scoped>
  .content-background {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    z-index: 0;

    &--overlay {
      &-1 {
        &::before {
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          z-index: 0;
          background-color: rgba(0,0,0,0.1);
        }
      }

      &-2 {
        &::before {
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          z-index: 0;
          background-color: rgba(0,0,0,0.2);
        }
      }

      &-3 {
        &::before {
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          z-index: 0;
          background-color: rgba(0,0,0,0.3);
        }
      }

      &-4 {
        &::before {
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          z-index: 0;
          background-color: rgba(0,0,0,0.4);
        }
      }

      &-5 {
        &::before {
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          z-index: 0;
          background-color: rgba(0,0,0,0.5);
        }
      }

      &-6 {
        &::before {
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          z-index: 0;
          background-color: rgba(0,0,0,0.6);
        }
      }

      &-7 {
        &::before {
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          z-index: 0;
          background-color: rgba(0,0,0,0.7);
        }
      }

      &-8 {
        &::before {
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          z-index: 0;
          background-color: rgba(0,0,0,0.8);
        }
      }

      &-9 {
        &::before {
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          z-index: 0;
          background-color: rgba(0,0,0,0.9);
        }
      }
    }
    &__image {
      width: 100%;
      height: -webkit-fill-available;
      object-fit: cover;
    }
  }
</style>
